module.exports = __webpack_public_path__ + "static/media/00_central.75def316.jpg";